"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Router = void 0;
var uuid = require("uuid");
function getPathData(registry, pathParts) {
    for (var key in registry) {
        var reg = registry[key];
        if (reg.pathParts.length === pathParts.length) {
            var params = {};
            var match = true;
            for (var i in reg.pathParts) {
                if (reg.pathParts[i].charAt(0) === ':') {
                    params[reg.pathParts[i].substring(1)] = pathParts[i];
                }
                else if (reg.pathParts[i] !== pathParts[i]) {
                    match = false;
                    break;
                }
            }
            if (match) {
                return {
                    component: reg.route.component,
                    params: params,
                    props: reg.route.props
                };
            }
        }
    }
}
function onPathChange(registry, listener, defaultRoute, path, options) {
    var exec = registry[path];
    if (exec) {
        listener(exec.route.component, {}, exec.route.props, options);
        return;
    }
    var pathParts = path.split('?')[0].split('/');
    var data = getPathData(registry, pathParts);
    if (data) {
        listener(data.component, data.params, data.props, options);
    }
    else {
        if (defaultRoute) {
            listener(defaultRoute.component, {}, defaultRoute.props, options);
        }
    }
}
function router() {
    var registry = {};
    var pathChangeSubs = [];
    var beforeNavigateHandlers = [];
    var defaultRoute;
    var currentPath = '';
    var listener;
    var suffix = '';
    window.addEventListener('popstate', function () {
        currentPath = window.location.pathname;
        push(window.location.pathname);
    });
    function push(path, options) {
        onPathChange(registry, listener, defaultRoute, path, options);
        pathChangeSubs.forEach(function (e) {
            e.callback(path);
        });
    }
    var self = {
        setTitleSuffix: function (_suffix) {
            suffix = "| " + _suffix;
        },
        setTitle: function (title) {
            document.title = title + " " + suffix;
        },
        listen: function (_listener) {
            listener = _listener;
        },
        register: function (_routes, dRoute, base) {
            if (dRoute) {
                defaultRoute = dRoute;
            }
            if (typeof base === 'undefined') {
                base = '';
            }
            _routes.forEach(function (route) {
                if (route.children) {
                    self.register(route.children, undefined, base + route.path);
                }
                registry[base + route.path] = {
                    id: uuid.v4(),
                    pathParts: (base + route.path).split('/'),
                    route: {
                        component: route.component,
                        path: route.path,
                        props: route.props
                    }
                };
            });
        },
        unregister: function (path) {
            if (registry[path]) {
                delete registry[path];
            }
        },
        beforeNavigate: function (handler) {
            var id = uuid.v4();
            beforeNavigateHandlers.push({
                id: id,
                handler: handler
            });
            return function () {
                for (var i = 0; i < beforeNavigateHandlers.length; i++) {
                    if (beforeNavigateHandlers.find(function (e) { return e.id === id; })) {
                        beforeNavigateHandlers.splice(i, 1);
                        return;
                    }
                }
            };
        },
        navigate: function (path, options) {
            var _this = this;
            var loop = function () { return __awaiter(_this, void 0, void 0, function () {
                var i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < beforeNavigateHandlers.length)) return [3, 4];
                            return [4, beforeNavigateHandlers[i].handler(path)];
                        case 2:
                            if ((_a.sent()) === false) {
                                return [2, false];
                            }
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3, 1];
                        case 4: return [2, true];
                    }
                });
            }); };
            loop().then(function (result) {
                if (!result) {
                    return;
                }
                if (path === currentPath) {
                    currentPath = path;
                    push(path, options);
                    return;
                }
                currentPath = path;
                if (options) {
                    if (!options.push) {
                        if (options.replace) {
                            window.history.replaceState(options.data, '', path);
                        }
                        else {
                            window.history.pushState(options.data, '', path);
                        }
                    }
                }
                else {
                    window.history.pushState(undefined, '', path);
                }
                push(path, options);
            });
        },
        path: function () {
            return currentPath;
        },
        subscribeToPathChange: function (callback) {
            var id = uuid.v4();
            pathChangeSubs.push({
                id: id,
                callback: callback
            });
            return function () {
                for (var i = 0; i < pathChangeSubs.length; i++) {
                    if (pathChangeSubs[i].id === id) {
                        pathChangeSubs.splice(i, 1);
                        break;
                    }
                }
            };
        },
        isAvailable: function (path) {
            var pathParts = path.split('?')[0].split('/');
            var data = getPathData(registry, pathParts);
            return data ? true : false;
        },
        back: function () {
            window.history.back();
        },
        forward: function () {
            window.history.forward();
        }
    };
    return self;
}
exports.Router = router();
//# sourceMappingURL=core.js.map